"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Counter = require("./Counter");

var _Counter2 = _interopRequireDefault(_Counter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Counter2.default;